module.exports = "/images/vendor/dhtmlx-scheduler/codebase/imgs_dhx_material/drag-vertical.svg?028a39de72af7c3d50edfffa6eaacbac";